import type { SVGProps } from 'react';

export const SvgImgIllustHikari = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 202 172" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M100.001 159.872L0 102.137L99.9993 44.403L200 102.138L100.001 159.872Z"
      fill="#FBDED7"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M0 112.223V102.137L100.001 159.872V169.958L0 112.223Z"
      fill="url(#paint0_linear_4444_2045)"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M199.999 102.138V112.223L100 169.958V159.872L199.999 102.138Z"
      fill="url(#paint1_linear_4444_2045)"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M138.819 44.5013C137.207 36.5518 133.274 29.4457 127.756 23.9209C121.905 18.0627 114.27 13.993 105.738 12.5755C103.557 12.2132 101.32 12.0146 99.0361 12.0146C79.205 12.0146 62.7058 26.2383 59.1579 45.0376C58.8665 46.5826 58.6636 48.158 58.552 49.7595C58.4868 50.7016 58.4419 51.6509 58.4419 52.6089C58.4419 66.9297 65.8639 79.5084 77.0643 86.7347C83.3993 90.8219 90.9373 93.2031 99.0361 93.2031C121.456 93.2031 139.63 75.0285 139.63 52.6089C139.63 49.832 139.349 47.1203 138.819 44.4999V44.5013Z"
      fill="#70C0DB"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M137.909 40.8997C136.64 37.3025 132.819 27.492 124.5 21.0048C121.087 20.5686 119.516 22.573 115.339 27.492C111.91 31.5298 109.059 33.5632 103.814 33.7241C101.921 33.7821 95.8861 29.2993 93.1628 28.2761C89.4438 26.8804 87.0872 29.3355 84.5248 31.5153C82.1116 33.5705 79.3869 35.185 79.2333 39.3185C79.1796 40.7389 80.7493 41.6635 81.1478 43.5375C81.7884 46.555 81.5884 50.6044 83.1595 52.4291C87.4104 57.3655 91.2859 61.257 95.0947 68.9544C97.3629 73.5386 100.953 71.711 106.324 71.7385C110.068 71.7588 116.781 75.3024 120.141 72.7226C123.178 70.3906 123.928 64.9499 126.003 62.586C127.942 60.3758 130.061 57.0699 130.231 52.8306C130.471 46.7854 133.385 44.7796 137.909 40.8997Z"
      fill="#88BE43"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M81.7312 73.6631C81.7312 71.4152 80.5529 70.9746 83.1834 68.6905C84.8385 67.2527 85.1675 62.5366 80.7007 60.6902C78.6209 59.8293 74.6324 58.5249 72.6033 58.1712C68.867 57.5205 67.8336 55.3508 64.5161 54.2986C62.287 53.5914 60.6029 53.3798 58.4463 54.8436C60.384 77.4371 75.2541 86.6766 84.6067 90.2651C84.8052 90.326 85.9821 84.9765 85.2661 82.8997C83.1849 76.8632 81.7326 79.0097 81.7326 73.6631H81.7312Z"
      fill="#88BE43"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M104.992 78.8185C101.886 78.4706 96.0104 73.6632 93.6103 77.0271C91.4725 80.0243 97.5655 85.6622 100.1 86.6637C102.689 87.6869 105.547 87.2231 108.04 86.1274C110.105 85.2201 113.801 83.6172 114.398 81.1128C115.223 77.6576 108.375 79.1938 104.992 78.8156V78.8185Z"
      fill="#88BE43"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M80.5995 16.4453C80.2966 19.8309 79.5632 26.9312 76.9544 27.3935C71.9702 28.2762 71.376 22.9107 71.376 22.9107C71.376 22.9107 75.7428 18.7454 80.5995 16.4438V16.4453Z"
      fill="#88BE43"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M64.7922 75.1834C61.8515 81.3445 61.2573 86.2737 63.6154 88.9854C69.6402 95.9103 92.6498 85.7534 115.009 66.3005C137.367 46.8476 150.61 25.4642 144.585 18.5408C141.436 14.9204 133.643 15.9697 123.728 20.5742"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M134.737 32.8473C141.553 32.4661 146.339 33.785 147.952 36.9981C152.072 45.1999 133.943 62.6324 107.459 75.9358C80.9754 89.2392 56.1673 93.3741 52.0468 85.1724C49.9656 81.0302 53.5599 74.5343 61.0385 67.4036"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M71.1482 22.9253C64.5219 21.2803 59.5739 21.6861 57.3912 24.5413C51.8156 31.8328 66.3814 52.3365 89.9228 70.3386C113.466 88.3407 137.069 97.025 142.645 89.7335C145.56 85.9217 142.97 78.4983 136.469 69.7081"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <defs>
      <linearGradient
        id="paint0_linear_4444_2045"
        x1="52.0309"
        y1="132.587"
        x2="46.1524"
        y2="142.604"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#F29E8A"></stop>
        <stop offset="0.29" stopColor="#F5B3A4"></stop>
        <stop offset="0.75" stopColor="#F9D2C8"></stop>
        <stop offset="1" stopColor="#FBDED7"></stop>
      </linearGradient>
      <linearGradient
        id="paint1_linear_4444_2045"
        x1="150.289"
        y1="177.182"
        x2="149.786"
        y2="105.611"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#F29E8A"></stop>
        <stop offset="0.51" stopColor="#ED8B7D"></stop>
        <stop offset="1" stopColor="#EB7D74"></stop>
      </linearGradient>
    </defs>
  </svg>
);
